'use client';

import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["error", "size", "isHover", "isFocus", "className"];
import React, { useContext } from 'react';
import cx from 'classnames';
import { BrowserDefaultFocusStyleContext } from "../../contexts/BrowserDefaultFocusStyleContext.mjs";
import { KeyboardDetectionContext } from "../../contexts/KeyboardDetectionContext.mjs";
import { ENCORE_DATA_IDS } from "../../dataEncoreIds.mjs";
import { Input } from "./Input.mjs";
import { textClass } from "../../styles/index.mjs";
export var FormInput = /*#__PURE__*/React.forwardRef(function FormInput(_ref, ref) {
  var error = _ref.error,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'medium' : _ref$size,
    isHover = _ref.isHover,
    isFocus = _ref.isFocus,
    className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useContext = useContext(KeyboardDetectionContext),
    isUsingKeyboard = _useContext.isUsingKeyboard;
  var _useContext2 = useContext(BrowserDefaultFocusStyleContext),
    useBrowserDefaultFocusStyle = _useContext2.useBrowserDefaultFocusStyle;
  return /*#__PURE__*/React.createElement(Input, Object.assign({
    ref: ref,
    $isUsingKeyboard: isUsingKeyboard,
    $useBrowserDefaultFocusStyle: useBrowserDefaultFocusStyle,
    $size: size,
    $error: error,
    $isHover: isHover,
    $isFocus: isFocus,
    "aria-invalid": error,
    className: cx(size === 'small' ? textClass('bodySmall') : textClass('bodyMedium'), className),
    "data-encore-id": ENCORE_DATA_IDS.FormInput
  }, props));
});